import React from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import { Box, Divider, Grid, Typography } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";

export default function ClassDetailsCard({ classDetails }) {
    const currentDate = new Date().toISOString().split("T")[0];
  return (
    <GlobalCard >
      <Grid container spacing={2} pr={2}>
        <Grid item xs={12}>
          <Typography
            color="#000000"
            fontFamily="Inter"
            fontSize="20px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 400 }}
          >
            Class Details
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Box>
            <img src="/newdashboard/Classrom/Rectangle 111141662.png" />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2} ml={2} mb={2} >
            <Grid item xs={12}>
              <Box display="flex" alignItems="flex-start" gap={2} >
                {/* ICON */}
                <Box width={20}>
                  {" "}
                  <img src="/newdashboard/Classrom/famicons_book-sharp.png" />
                </Box>

                {/* Text Content: Title + Subtitle */}
                <Box display="flex" flexDirection="column">
                  <Typography
                    fontFamily="Inter"
                    fontWeight={400}
                    fontStyle="normal"
                    fontSize="14px"
                    color="#9D0385"
                  >
                    Class Name
                  </Typography>

                  <Typography
                    fontFamily="Inter"
                    fontWeight={400}
                    fontStyle="normal"
                    fontSize="15px"
                    color="#000000"
                    mt={0.3}
                  >
                    {classDetails?.class_id?.name}
                  </Typography>
                </Box>
              </Box>
            </Grid>

  <Grid item xs={12}>
              <Box display="flex" alignItems="flex-start" gap={2} >
                {/* ICON */}
                <Box width={20}>
                  {" "}
                  <img src="/newdashboard/Classrom/famicons_book-sharp.png" />
                </Box>

                {/* Text Content: Title + Subtitle */}
                <Box display="flex" flexDirection="column">
                  <Typography
                    fontFamily="Inter"
                    fontWeight={400}
                    fontStyle="normal"
                    fontSize="14px"
                    color="#9D0385"
                  >
                    Package Name
                  </Typography>

                  <Typography
                    fontFamily="Inter"
                    fontWeight={400}
                    fontStyle="normal"
                    fontSize="15px"
                    color="#000000"
                    mt={0.3}
                  >
                    {classDetails?.package_id?.package_name}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" alignItems="flex-start" gap={2}>
                {/* ICON */}
                <Box width={20}>
                  {" "}
                  <img src="/newdashboard/Classrom/bxs_user.png" />
                </Box>

                {/* Text Content: Title + Subtitle */}
                <Box display="flex" flexDirection="column">
                  <Typography
                    fontFamily="Inter"
                    fontWeight={400}
                    fontStyle="normal"
                    fontSize="14px"
                    color="#9D0385"
                  >
                    Trainer Name
                  </Typography>

                  <Typography
                    fontFamily="Inter"
                    fontWeight={400}
                    fontStyle="normal"
                    fontSize="15px"
                    color="#000000"
                    mt={0.3}
                  >
                    {classDetails?.class_id?.trainer_id?.first_name}{" "}
                    {classDetails?.class_id?.trainer_id?.last_name}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" alignItems="flex-start" gap={2}>
                {/* ICON */}
                <Box width={20} flexShrink={0}>
                  {" "}
                  <img src="/newdashboard/Classrom/famicons_book-sharp.png" />
                </Box>

                {classDetails?.class_id?.mode_of_delivery === "offline" && (
                  <Box display="flex" flexDirection="column">
                    <Typography
                      fontFamily="Inter"
                      fontWeight={400}
                      fontStyle="normal"
                      fontSize="14px"
                      color="#9D0385"
                    >
                      {classDetails?.class_id?.mode_of_delivery} Mode
                    </Typography>

                    <Typography
                      fontFamily="Inter"
                      fontWeight={400}
                      fontStyle="normal"
                      fontSize="15px"
                      color="#000000"
                      mt={0.3}
                       sx={{
    minWidth: 0,              // 🔴 Important for flex
    maxWidth: "100%",         // 🔴 Prevent overflow
    whiteSpace: "normal",     // Allow wrapping
    wordBreak: "break-word",
    overflowWrap: "anywhere", // Force break if needed
  }}
                    >
                      {classDetails?.class_id?.branch_id?.address}
                    </Typography>
                  </Box>
                )}

                {classDetails?.class_id?.mode_of_delivery === "online" && (
                  <Box display="flex" flexDirection="column">
                    <Typography
                      fontFamily="Inter"
                      fontWeight={400}
                      fontStyle="normal"
                      fontSize="14px"
                      color="#9D0385"
                    >
                      {classDetails?.class_id?.mode_of_delivery} Mode
                    </Typography>

                    <Typography
                      fontFamily="Inter"
                      fontWeight={400}
                      fontStyle="normal"
                      fontSize="15px"
                      color="#000000"
                      mt={0.3}
                    >
                      Virtual 
                      {currentDate >= classDetails?.enrollment_date && ( 
                        <>
                        <span style={{marginLeft:'5px'}}>-</span>
                        
                      <a
                        href={classDetails?.class_id?.zoom_link}
                        target="_blank"
                        style={{
                          cursor: "pointer",
                          color: "#007BFF",
                          textDecoration: "underline",
                          fontWeight: 700,
                          marginLeft:"5px"
                        }}
                      >
                        Join
                      </a>
                      </>
                      )}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
             <Grid item xs={12}>
                      <Grid container spacing={2} >
                        <Grid item xs={12}>
                          <Box display="flex" alignItems="flex-start" gap={2}>
                            {/* ICON */}
                            <Box width={20}>
                              {" "}
                              <img src="/newdashboard/Classrom/lets-icons_date-range.png"/>
                            </Box>
            
                            {/* Text Content: Title + Subtitle */}
                            <Box display="flex" flexDirection="column">
                              <Typography
                                fontFamily="Inter"
                                fontWeight={400}
                                fontStyle="normal"
                                fontSize="14px"
                                color="#9D0385"
                              >
                               Start Date
                              </Typography>
            
                              <Typography
                                fontFamily="Inter"
                                fontWeight={400}
                                fontStyle="normal"
                                fontSize="15px"
                                color="#000000"
                                mt={0.3}
                              >
                                {classDetails?.enrollment_date}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
            
                        <Grid item xs={12}>
                          <Box display="flex" alignItems="flex-start" gap={2}>
                            {/* ICON */}
                            <Box width={20}>
                              {" "}
                              <img src="/newdashboard/Classrom/lets-icons_date-range.png" />
                            </Box>
            
                            {/* Text Content: Title + Subtitle */}
                            <Box display="flex" flexDirection="column">
                              <Typography
                                fontFamily="Inter"
                                fontWeight={400}
                                fontStyle="normal"
                                fontSize="14px"
                                color="#9D0385"
                              >
                               End Date
                              </Typography>
            
                              <Typography
                                fontFamily="Inter"
                                fontWeight={400}
                                fontStyle="normal"
                                fontSize="15px"
                                color="#000000"
                                mt={0.3}
                              >
                               {classDetails?.end_date}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
            
                        <Grid item xs={12}>
                          <Box display="flex" alignItems="flex-start" gap={2}>
                            {/* ICON */}
                            <Box width={20}>
                              {" "}
                              <img src="/newdashboard/Classrom/mingcute_time-fill.png" />
                            </Box>
            
                            {/* Text Content: Title + Subtitle */}
                            <Box display="flex" flexDirection="column">
                              <Typography
                                fontFamily="Inter"
                                fontWeight={400}
                                fontStyle="normal"
                                fontSize="14px"
                                color="#9D0385"
                              >
                              Class Days
                              </Typography>
            
                              <Typography
                                fontFamily="Inter"
                                fontWeight={400}
                                fontStyle="normal"
                                fontSize="15px"
                                color="#000000"
                                mt={0.3}
                              >
                                {classDetails?.class_id?.day?.map(day => day).join(", ")}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
          </Grid>
        </Grid>
      </Grid>
    </GlobalCard>
  );
}
